import { MetaFunction, Outlet, useLocation } from "@remix-run/react";
import { useAtomValue } from "jotai";
import LoadingIndicator from "~/components/loading-indicator";

import Stepper from "~/components/stepper";
import { isLoadingAtom } from "~/lib/jotai/loading";
import { steps } from "~/models/generalConstants";
import { validateRegionAccess } from "~/lib/middleware/region";
import { Regions } from "~/models/region";

export const meta: MetaFunction = ({ matches }) => {
	return [
		...matches[0].meta.slice(1),
		{ title: "Collision Other Vehicles Involved" },
	];
};

export async function loader() {
	validateRegionAccess(Regions.Barbados.code);

	return null;
}

export default function AboutYou() {
	const isLoading = useAtomValue(isLoadingAtom);

	const location = useLocation();

	const path = location.pathname.split("/");
	const currentPath = path[path.length - 1];
	const currentStep = steps.findIndex((step) => step.slug === currentPath);

	return (
		<div className="flex flex-col items-center px-4 justify-center min-h-screen">
			{isLoading && <LoadingIndicator />}

			<h2 className="font-semibold text-sm mt-12 p-4 bg-companyGray/50 border-thin border-companyGray rounded-t-xl text-slate-400">
				MOTOR - COLLISION OTHER VEHICLES INVOLVED
			</h2>
			<div className="w-full max-w-7xl p-8 mb-10 bg-white rounded-lg shadow-[0_8px_30px_rgba(0,0,0,0.12)]">
				<Stepper steps={steps} currentStep={currentStep} />

				<Outlet />
			</div>
		</div>
	);
}
